import { pretendard } from './pretendard';

/**
 * 콘솔에서 사용할 font 리소스에 대한 font-face 정의를 모아둔 컴포넌트
 * 적용할 font-face에 해당하는 폰트 파일을 불러오는 정의는 포함되어 있지 않음, 다만 `next/font/local`을 사용할 경우 변수를 호출하는 것만으로 Next에서 내장으로 폰트파일을 불러오도록 동작함
 */
export const FontFaceDefinitions = () => {
  return (
    <>
      <style className={pretendard.className} />
    </>
  );
};
